import { createSlice } from "@reduxjs/toolkit";
import { checkoutCart } from "./thunks";
import { toast } from "react-toastify";

const initialState = {
    items: [],
    subtotal: 0,
    taxes: 0,
    shipping: 0,
    total: 0,
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        clearCart: (state, action) => {
            state.items    = [];
            state.subtotal = 0;
            state.taxes    = 0;
            state.shipping = 0;
            state.total    = 0;
        },
        addToCart: (state, action) => {
            const { productId, cover, price, title, quantity } = action.payload;
            const existingItem = state.items.find(item => item.productId === productId);

            if (existingItem) {
                existingItem.quantity += quantity;
            } else {
                state.items.push({ productId, cover, price, title, quantity });
            }

            // Recalculate totals
            state.subtotal = state.items.reduce((acc, item) => acc + item.price * item.quantity, 0);
            state.taxes = state.subtotal * 0.1;
            state.shipping = state.subtotal > 100 ? 0 : 10;
            state.total = state.subtotal + state.taxes + state.shipping;
        },
        increaseQuantity: (state, action) => {
            const { productId } = action.payload;
            const existingItem = state.items.find(item => item.productId === productId);
            if (existingItem) {
                existingItem.quantity += 1;
            }
        },
        decreaseQuantity: (state, action) => {
            const { productId } = action.payload;
            const existingItem = state.items.find(item => item.productId === productId);
            if (existingItem && existingItem.quantity > 1) {
                existingItem.quantity -= 1;
            }
        },
        removeFromCart: (state, action) => {
            const { productId } = action.payload;
            const itemIndex = state.items.findIndex(item => item.productId === productId);
            if (itemIndex !== -1) {
                const [removedItem] = state.items.splice(itemIndex, 1);
                state.subtotal -= removedItem.price * removedItem.quantity;
                state.taxes = state.subtotal * 0.1;
                state.shipping = state.subtotal > 100 ? 0 : 10;
                state.total = state.subtotal + state.taxes + state.shipping;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkoutCart.fulfilled, (state, action) => {
                toast.info(action.payload.message);
                return { ...initialState };
            })
            .addCase(checkoutCart.rejected, (state, action) => {
                toast.error(action.payload);
            });
    },
});

export const { clearCart, addToCart, increaseQuantity, decreaseQuantity, removeFromCart } = cartSlice.actions;
export default cartSlice.reducer;
